import { styled } from "@mui/material/styles";
import { Paper as MuiPaper, Grid, Typography, Link } from "@mui/material";

import useBusinessTheme from "../../hooks/useBusinessTheme";

const Paper = styled(MuiPaper)`
  margin: 2px 10px;
  padding: 15px 10px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

export default function PoweredBy() {
  const theme = useBusinessTheme();
  const name = theme?.name || "DigiPass";

  return (
    <Paper>
      <GridContainer container>
        <Grid item xs>
          <Link href="#" sx={{ color: "rgb(57, 54, 239)", fontWeight: 900 }}>
            Powered By Verismart.ai
          </Link>
        </Grid>

        <Grid item xs>
          <Typography variant="subtitle2" align="right">
            © {name} {new Date().getFullYear()}
          </Typography>
        </Grid>
      </GridContainer>
    </Paper>
  );
}
